import { createSlice } from '@reduxjs/toolkit';

export const purchaseSlice = createSlice({
  name: 'purchasePlan',
  initialState: {
    purchasePlan: null
  },
  reducers: {
    addPurchasePlan: (state, action) => {
      state.purchasePlan = action.payload;
    },
    removePurchasePlan: (state) => {
      state.purchasePlan = null;
    }
  },
});

export const { addPurchasePlan, removePurchasePlan } = purchaseSlice.actions;

export const selectPurchasePlan = (state) => state.purchasePlan.purchasePlan;

export default purchaseSlice.reducer;
